export function scrollToReviewsSmooth() {
  document.querySelector('#review-scroll')?.addEventListener('click', (e) => {
    e.preventDefault();

    const button = document.querySelector('button[aria-controls="open-reviews"]');

    // Make sure reviews are open before scrolling for mobile users
    if (
      button.getAttribute('aria-expanded') === 'false'
    ) {
      button.click();
    }

    document.querySelector('#open-reviews').scrollIntoView({ behavior: 'smooth' });
  });
}
